<template>
  <div id="edit-invoice">
    <b-container fluid>
      <b-row>
        <b-col cols="12">
          <b-form class="form" inline>
            <label class=" mx-5" for="invoice"
              >เลขที่{{ documentTypeName }}</label
            >
            <b-input
              id="invoice"
              v-model="inValue"
              class="col-md-2 mb-2 mr-5 mb-sm-0"
            />
            <label class=" mr-5" for="datepicker-trigger-edit-document"
              >วันที่ออกเอกสาร</label
            >
            <div class="date-box">
              <div class="select-box">
                <div
                  class="datepicker-trigger-edit-document input-group"
                  @mouseover="activeCloseDate = true"
                  @mouseleave="activeCloseDate = false"
                >
                  <input
                    id="datepicker-trigger-edit-document"
                    class="form-control border-right-0"
                    type="text"
                    autocomplete="off"
                    placeholder="เลือกวันที่"
                    :value="formatDates(date)"
                  />
                  <div class="input-group-prepend bg-white">
                    <span
                      id="basic-addon1"
                      class="input-group-text border-left-0 rounded-right bg-white"
                      ><fa-icon
                        :style="{
                          opacity: activeCloseDate ? 1 : 0,
                        }"
                        :icon="['fas', 'times']"
                        class="icon"
                        @click="clearDate"
                      />
                    </span>
                  </div>

                  <AirbnbStyleDatepicker
                    :trigger-element-id="'datepicker-trigger-edit-document'"
                    :mode="'single'"
                    style="left: 0 !important;"
                    :show-shortcuts-menu-trigger="false"
                    :fullscreen-mobile="true"
                    :date-one="date"
                    @date-one-selected="(val) => setDateInvoice(val)"
                  />
                </div>
              </div>
            </div>
            <b-col cols="4" class="ml-1 text-left">
              <b-button
                class="create-document-btn"
                :disabled="!canEdit"
                @click="editDocument"
              >
                บันทึก
              </b-button>
              <b-button
                class="delete-document-btn ml-3"
                @click="deleteDocument"
              >
                ลบ
              </b-button>
            </b-col>
          </b-form>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import format from "date-fns/format";
import { mapActions } from "vuex";

export default {
  name: "EditInvoiceComponent",
  props: {
    invoiceNumber: {
      type: String,
    },
    dateInvoice: {},
    documentTypeName: {
      type: String,
    },
    documentId: {
      type: Number,
    },
  },
  data() {
    return {
      inValue: "",
      date: "",
      activeCloseDate: false,
      canEdit: false,
      dateFormat: "D/MM/YYYY",
    };
  },
  mounted() {
    this.inValue = this.invoiceNumber;
    this.date = this.dateInvoice;
  },
  methods: {
    ...mapActions({
      editDocumentService: "Account/editDocument",
      setDocument: "Account/setDocument",
      deleteDocumentService: "Account/deleteDocument",
    }),
    clearDate() {
      this.date = "";
    },
    setDateInvoice(val) {
      this.date = val;
    },
    formatDates(dateOne, dateTwo) {
      let formattedDates = "";
      if (dateOne) {
        formattedDates = format(dateOne, this.dateFormat);
      }
      if (dateTwo) {
        formattedDates += " - " + format(dateTwo, this.dateFormat);
      }
      return formattedDates;
    },
    async editDocument() {
      let data = await this.editDocumentService({
        id: this.documentId,
        number: this.inValue,
        date: this.date,
      });

      if (typeof data !== "string") {
        this.inValue = data.in;
        this.date = data.created_date;
        this.setDocument(data.id);
      }
    },
    async deleteDocument() {
      let data = await this.deleteDocumentService(this.documentId);

      if (data) {
        this.$router.push({ name: "account" });
      }
    },
  },
  watch: {
    inValue(newVal, oldVal) {
      this.canEdit = newVal !== "" && this.date !== "";
    },
    date(newVal, oldVal) {
      this.canEdit = newVal !== "" && this.inValue !== "";
    },
  },
};
</script>

<style lang="scss" scoped>
.create-document-btn {
  background-color: #009906;
  border: none;

  &:disabled {
    background-color: #999999;
  }
}
.delete-document-btn {
  background-color: #e20000;
  border: none;

  &:disabled {
    background-color: #999999;
  }
}

.datepicker-trigger-edit-document {
  display: flex;
}
.select-box {
  margin: 0px 5px 0px 5px;
  justify-content: center;
  width: 20vw;
  padding-left: 0px;
}
.flex {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
  margin-left: 0px;
}
.date-box {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 10vw;
}
.form {
  width: 100%;
}
</style>
